import React, { Component } from "react";
import Select from "react-select";
import { Input } from "reactstrap";
import MPSButton from "../../../../components/Buttons/Buttons/MPSButton";
import MPSSelect from "../../../../components/MPSSelect";
import Messages from "../../../Messages";
import Text from "../../../../components/Text";
import dateFormatService from "../../../../services/dateFormatService";
import FeaturesService from "../../../../services/featuresService";
import MPSTypeaheadSelect from "../../../../components/MPSTypeaheadSelect/MPSTypeaheadSelect";
import terminologyService from "../../../../services/terminologyService";

class StringObservation extends Component {
  static getDisplayValue(attributeValue, valuePlace, multi) {
    if (
      multi &&
      attributeValue.valueObservation &&
      attributeValue.valueObservation.values
    ) {
      return attributeValue.valueObservation.values
        .map((v) => v.valueCode?.display || v.valueString)
        .join(", ");
    }

    if (
      !multi &&
      attributeValue.valueObservation &&
      attributeValue.valueObservation.value
    ) {
      let value;
      if (valuePlace === "from") {
        value = attributeValue.valueObservation.value.valueFromString;
      } else if (valuePlace === "to") {
        value = attributeValue.valueObservation.value.valueToString;
      } else {
        value = attributeValue.valueObservation.value.valueString;
      }

      // Check if this is a known date-string observation and format it
      if (value && attributeValue.valueObservation.code) {
        return dateFormatService.formatStringObservationIfDate(
          value,
          attributeValue.valueObservation.code
        );
      }

      return value;
    }
  }

  static getOptionsList(options) {
    return options.map((option) => {
      let val = option.valueObservation.value.valueString;
      return { value: val, label: val };
    });
  }

  static getTranslationStatus(av) {
    let value =
      av.valueObservation?.value?.translationStatus?.valueString ?? null;
    return value;
  }

  setValue = (option) => {
    let { attributeValue, multi, setData } = this.props;
    if (multi) {
      if (option) {
        attributeValue.valueObservation.values = option.map((o) => ({
          valueString: o.value,
          display: o.label,
        }));
      } else {
        attributeValue.valueObservation.values = [];
      }
    } else {
      if (option) {
        attributeValue.valueObservation.value.valueString = option.value;
      } else {
        attributeValue.valueObservation.value = {};
      }
    }
    setData(attributeValue);
  };

  getValue = () => {
    let { attributeValue, multi } = this.props;
    if (multi) {
      let values = attributeValue.valueObservation.values || [];
      return values.map((v) => v.valueString || v.valueCode?.code);
    }
    return attributeValue.valueObservation.value.valueString;
  };

  setTextValue = (index, value) => {
    let { attributeValue, setData } = this.props;
    let values = attributeValue.valueObservation.values || [];
    values[index] = { valueString: value };
    attributeValue.valueObservation.values = [...values];
    setData(attributeValue);
  };

  addTextValue = () => {
    let { attributeValue, setData } = this.props;
    let values = attributeValue.valueObservation.values || [];
    values.push({ valueString: "" });
    attributeValue.valueObservation.values = [...values];
    setData(attributeValue);
    this.props.onBlur();
  };

  removeTextValue = (index) => {
    let { attributeValue, setData } = this.props;
    let values = attributeValue.valueObservation.values || [];
    values = [...values];
    values.splice(index, 1);
    attributeValue.valueObservation.values = values;
    setData(attributeValue);
    this.props.onBlur();
  };

  //KLC MAY 09 2024 added creatable - for GP NAME only (it is hoped)
  render() {
    let {
      attributeValue,
      choiceList,
      options = [],
      setData,
      observationCode,
      multi,
      creatable,
      isMultiLine,
      noOfLinesInMultiline,
      noOfWordsInMultiline,
    } = this.props;
    attributeValue.valueObservation = attributeValue.valueObservation || {};
    attributeValue.valueObservation.value =
      attributeValue.valueObservation.value || {};
    let obsVal = attributeValue.valueObservation.value.valueString;
    attributeValue.valueObservation.code = observationCode;

    // Terminology typeahead: when attribute has terminologyLookup, choiceList is on, and feature flag is on
    let terminologyLookup = this.props.terminologyLookup;
    if (
      FeaturesService.isTerminologyEnabled() &&
      terminologyLookup &&
      choiceList
    ) {
      const searchFn = terminologyService.getSearchFnForLookup(
        terminologyLookup
      );
      const isECL = terminologyService.isECLLookup(terminologyLookup);

      if (multi) {
        // Multi-select: values stored in valueObservation.values[]
        const currentValues = (attributeValue.valueObservation.values || [])
          .map((v) => ({
            code: v.valueCode?.code || v.valueString || "",
            display: v.valueCode?.display || v.valueString || "",
            system: v.valueCode?.system || "",
          }))
          .filter((v) => v.code);

        return (
          <div className="inputHolder flex-row">
            <MPSTypeaheadSelect
              searchFn={searchFn}
              eagerLoad={isECL}
              value={currentValues}
              onChange={(selectedArray) => {
                attributeValue.valueObservation.values = selectedArray.map(
                  (s) => ({
                    valueString: s.code,
                    display: s.display,
                    valueCode: {
                      code: s.code,
                      display: s.display,
                      system: s.system,
                    },
                  })
                );
                setData(attributeValue);
                if (this.props.onBlur) {
                  setTimeout(() => this.props.onBlur(), 0);
                }
              }}
              multi
              showSystem
            />
          </div>
        );
      }

      // Single-select
      return (
        <div className="inputHolder flex-row">
          <MPSTypeaheadSelect
            searchFn={searchFn}
            eagerLoad={isECL}
            value={
              obsVal
                ? { code: obsVal, display: obsVal }
                : null
            }
            onChange={(selected) => {
              if (selected) {
                attributeValue.valueObservation.value.valueString =
                  selected.display;
                attributeValue.valueObservation.value.valueCode = {
                  code: selected.code,
                  display: selected.display,
                  system: selected.system,
                };
              } else {
                attributeValue.valueObservation.value.valueString = "";
                attributeValue.valueObservation.value.valueCode = null;
              }
              setData(attributeValue);
              if (this.props.onBlur) {
                setTimeout(() => this.props.onBlur(), 0);
              }
            }}
            showSystem
          />
        </div>
      );
    }

    if (choiceList) {
      return (
        <div className="inputHolder flex-row">
          <MPSSelect
            className="ui-attribute-el-select"
            name="form-field-name"
            value={this.getValue()}
            onChange={(option) => {
              this.setValue(option);
              // Save immediately after selection for better UX with conditional fields
              if (this.props.onBlur) {
                setTimeout(() => this.props.onBlur(), 0);
              }
            }}
            options={options.map((option) => {
              let val =
                option.valueObservation.value.valueString ||
                option.valueCode?.code;
              let display =
                option.valueObservation.value.valueString ||
                option.valueCode?.display;
              return { value: val, label: display };
            })}
            multi={multi}
            creatable={creatable}
            onBlur={this.props.onBlur}
            style={{
              minWidth: "150px",
              with: "auto",
              color: "#3e515b",
            }}
          />
        </div>
      );
    } else {
      if (multi) {
        let values = attributeValue.valueObservation.values || [];
        return (
          <div className="flex-column">
            {values.map((v, index) => (
              <div className="inputHolder mb-2 d-flex align-content-center">
                <Input
                  className="ui-attribute-el"
                  value={v.valueString}
                  onChange={(e) => {
                    this.setTextValue(index, e.target.value);
                  }}
                  type="text"
                  onBlur={this.props.onBlur}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && this.props.onEnterKey) {
                      e.preventDefault();
                      this.props.onEnterKey();
                    }
                  }}
                />
                <MPSButton
                  type="link"
                  onClick={() => {
                    this.removeTextValue(index);
                  }}
                  style={{ fontWeight: 500, marginLeft: "10px" }}
                >
                  <i className="fa fa-trash" />
                </MPSButton>
              </div>
            ))}
            <div className="inputHolder">
              <MPSButton
                type="link"
                onClick={this.addTextValue}
                style={{ fontWeight: 500 }}
              >
                <i className="fa fa-plus-square" />
                {" "}
                <Text content={Messages.add}/>
              </MPSButton>
            </div>
          </div>
        );
      }
      return (
        <div className="inputHolder flex-row">
          {isMultiLine ? (
            <div className="w-100">
              {this.state?.errorMessage && (
                <p style={{ color: "red" }}> {this.state.errorMessage}</p>
              )}
              <textarea
                className="ui-attribute-multiline"
                value={obsVal}
                onChange={(e) => {
                  const { value } = e.target;
                  const lines = value.split("\n");
                  const words = value
                    .split(/\s+/)
                    .filter((word) => word.length > 0);
                  if (words.length > noOfWordsInMultiline) {
                    this.setState({
                      text: lines.slice(0, noOfWordsInMultiline).join("\n"),
                      errorMessage: `You cannot enter more than ${noOfWordsInMultiline} words.`,
                    });
                  } else if (lines.length > noOfLinesInMultiline) {
                    this.setState({
                      text: lines.slice(0, noOfWordsInMultiline).join("\n"),
                      errorMessage: `You cannot enter more than ${noOfLinesInMultiline} lines.`,
                    });
                  } else {
                    attributeValue.valueObservation.value.valueString =
                      e.target.value;
                    setData(attributeValue, e.target.value);
                    this.setState({ errorMessage: null });
                  }
                }}
                onBlur={this.props.onBlur}
                rows={this.props.noOfLinesInMultiline}
              />
            </div>
          ) : (
            <Input
              className="ui-attribute-el"
              value={obsVal}
              onChange={(e) => {
                attributeValue.valueObservation.value.valueString =
                  e.target.value;
                setData(attributeValue, e.target.value);
              }}
              type={"text"}
              onBlur={this.props.onBlur}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && this.props.onEnterKey) {
                  e.preventDefault();
                  this.props.onEnterKey();
                }
              }}
            />
          )}
        </div>
      );
    }
  }
}

export default StringObservation;
